import React from "react";
import {getCategoryIcon} from './categoryIcons';
import InboxTaskItem from './InboxTaskItem';
import WaitingTaskItem from './WaitingTaskItem';
import ActiveTaskItem from './ActiveTaskItem';
import ScheduledTaskItem from './ScheduledTaskItem';
import TaskDetailsComponent from './TaskDetailsComponent';
import moment from 'moment';
import { authFetch, handleResponse, baseURL } from './utils';
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';

class TaskItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showDetails: false,
			activeSection: 'REMINDER',
			showTopFields: false,
			swipeDx: 0,
			swiping: false
		}
		this.toggleDetails = this.toggleDetails.bind(this);
		this.openDetails = this.openDetails.bind(this);
		this.closeDetails = this.closeDetails.bind(this);
		this.getState = this.getState.bind(this);
		this.checkPendingForLongTime = this.checkPendingForLongTime.bind(this);
		this.isRecurringTask = this.isRecurringTask.bind(this);
		this.getFormattedTime = this.getFormattedTime.bind(this);
		this.onTouchStart = this.onTouchStart.bind(this);
		this.onTouchMove = this.onTouchMove.bind(this);
		this.onTouchEnd = this.onTouchEnd.bind(this);
		this.markComplete = this.markComplete.bind(this);
	}

	onTouchStart(e) {
		this.touchStartX = e.touches[0].clientX;
		this.touchStartY = e.touches[0].clientY;
		this.swipeAxis = null;
	}

	onTouchMove(e) {
		if (this.touchStartX === undefined) return;
		var dx = e.touches[0].clientX - this.touchStartX;
		var dy = e.touches[0].clientY - this.touchStartY;
		if (this.swipeAxis === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8))
			this.swipeAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
		if (this.swipeAxis === 'x') {
			var capped = Math.max(-140, Math.min(140, dx));
			// already-completed tasks can't be completed again; recurring tasks aren't reschedulable
			if (this.props.item.taskDetails.completedDate !== null && capped > 0) capped = 0;
			if (this.isRecurringTask() && capped < 0) capped = 0;
			this.setState({ swipeDx: capped, swiping: true });
		}
	}

	onTouchEnd() {
		var dx = this.state.swipeDx;
		if (this.swipeAxis === 'x' && Math.abs(dx) > 10) this.suppressClick = true;
		this.swipeAxis = null;
		this.touchStartX = undefined;
		if (dx > 90) this.markComplete();
		else if (dx < -90) this.openDetails('REMINDER');
		this.setState({ swipeDx: 0, swiping: false });
	}

	markComplete() {
		var item = this.props.item;
		var td = item.taskDetails;
		var done = () => {
			if (this.props.showToast) this.props.showToast('"' + td.name + '" completed');
			this.props.onItemChanged();
		};
		if (this.isRecurringTask()) {
			authFetch(baseURL + '/v1/task/add', {
				method: 'POST',
				body: JSON.stringify({ name: td.name, completedFlag: true })
			}).then(res => handleResponse(res)).then(done);
			return;
		}
		var reminderType = 'FIXED';
		var reminderEndTime = null;
		if (td.reminder && td.reminder.auto) {
			reminderType = 'AUTO';
			reminderEndTime = td.reminder.endDate;
		}
		authFetch(baseURL + '/v1/task/update', {
			method: 'POST',
			body: JSON.stringify({
				id: td.id,
				previousTaskType: item.taskType,
				currentTaskType: item.taskType,
				area: td.area,
				name: td.name,
				categories: (item.categories || []).map(c => ({ name: c.name, id: c.id })),
				completedDate: moment(new Date()).format("DD-MMM-YYYY HH:mm"),
				effort: td.effort,
				priority: td.priority,
				completedFlag: true,
				reminderTime: td.reminder ? td.reminder.timeString : undefined,
				reminderEndTime,
				approxTimeInMinsToComplete: td.actualEffortInMins,
				projectName: td.project ? td.project.name : '',
				reminderType
			})
		}).then(res => handleResponse(res)).then(done);
	}

	isRecurringTask() {
		return this.props.item.taskDetails.reminder != null && this.props.item.taskDetails.reminder.cronexpr
	}

	openDetails(section) {
		this.setState({ showDetails: true, activeSection: section, showTopFields: false });
	}

	closeDetails() {
		this.setState({ showDetails: false });
	}

	toggleDetails() {
		if (this.suppressClick) {
			this.suppressClick = false;
			return;
		}
		this.setState(prev => ({ showDetails: !prev.showDetails, activeSection: 'REMINDER', showTopFields: true }));
	}

	getElement(item) {
		var allItem;
		if (item.taskType === 'INBOX') {
			allItem = <InboxTaskItem categories={this.props.categories} toggleDetails={this.toggleDetails} key={item.id} item={item} />;
		} else if (item.taskType === 'WAITING') {
			allItem = <WaitingTaskItem categories={this.props.categories} toggleDetails={this.toggleDetails} key={item.id} item={item} />;
		} else if (item.taskType === 'ACTIVE') {
			allItem = <ActiveTaskItem categories={this.props.categories} toggleDetails={this.toggleDetails} key={item.id} item={item} />;
		} else if (item.taskType === 'SCHEDULED') {
			allItem = <ScheduledTaskItem categories={this.props.categories} toggleDetails={this.toggleDetails} key={item.id} item={item} />;
		}
		return allItem
	}

	checkPendingForLongTime() {
		var now = new Date();
		now.setDate(now.getDate() - 30);
		if (this.props.item.taskDetails.createdDate != null) {
			var createdDate = Date.parse(this.props.item.taskDetails.createdDate);
			return now > createdDate;
		}
		return false;
	}

	getState() {
		var now = new Date();
		if (this.props.item.taskDetails.reminder != null
			&& this.props.item.taskDetails.reminder.time != null) {
			var reminderTime = new Date(this.props.item.taskDetails.reminder.time);
			if (reminderTime.getFullYear() === now.getFullYear()
				&& reminderTime.getDate() === now.getDate()
				&& reminderTime.getMonth() === now.getMonth())
				return "todaysreminder";
			else if (reminderTime < now) {
				return "passedoutreminder";
			} else
				return "scheduled";
		} else
			return "not-scheduled";
	}

	getFormattedTime(time) {
		const suggestedTime = moment(time)
		return suggestedTime.format("HH:mm")
	}

	render() {
		var status = this.getState();
		var isRecurringTask = this.isRecurringTask();
		var detailKey = this.props.item.id + "details";

		return <div className="mb-1 px-2 pt-2">
			<div className="swipe-stage">
				{this.state.swipeDx !== 0 && <div className={"swipe-under " + (this.state.swipeDx > 0 ? "swipe-complete" : "swipe-reschedule")}>
					{this.state.swipeDx > 0
						? <span><i className="bi bi-check-circle me-1"></i>Done</span>
						: <span><i className="bi bi-alarm me-1"></i>Reschedule</span>}
				</div>}
				<div className="swipe-track"
					style={{ transform: `translateX(${this.state.swipeDx}px)`, transition: this.state.swiping ? 'none' : 'transform 0.2s ease' }}
					onTouchStart={this.onTouchStart} onTouchMove={this.onTouchMove} onTouchEnd={this.onTouchEnd}>
			<Card eventKey={this.props.item.id} onClick={this.toggleDetails} style={this.props.item.taskDetails.priority === 'HIGH' ? { cursor: 'pointer', '--bs-card-bg': '#dc3545' } : { cursor: 'pointer' }} className="shadow-sm" bg={this.props.item.taskDetails.priority === 'HIGH' ? 'danger' : undefined} text={this.props.item.taskDetails.priority === 'HIGH' ? 'white' : undefined} border={status === 'passedoutreminder' ? 'danger' : status === 'not-scheduled' ? 'warning' : 'secondary'}>
				<Card.Header>
					<div className="d-flex align-items-center gap-2 flex-wrap">
						{!isRecurringTask && <>
							{status === 'passedoutreminder' && <Badge bg="warning"><i className="bi bi-clock-history me-1"></i>Passed Out</Badge>}
							{status === 'not-scheduled' && <Badge bg="warning"><i className="bi bi-clock me-1"></i>Not Scheduled</Badge>}
						</>
						}
						{this.props.item.taskDetails.priority && <Badge bg={this.props.item.taskDetails.priority === 'HIGH' ? 'danger' : this.props.item.taskDetails.priority === 'MEDIUM' ? 'warning' : 'secondary'}><i className="bi bi-flag-fill me-1"></i>{this.props.item.taskDetails.priority}</Badge>}
						{this.props.item.taskDetails.effort && <Badge bg="info" text="dark"><i className="bi bi-lightning-fill me-1"></i>{this.props.item.taskDetails.effort}</Badge>}
					</div>
				</Card.Header>
				<Card.Body>
					<Card.Title><i className="bi bi-card-text me-2"></i>{this.props.item.taskDetails.name}</Card.Title>
					{this.props.item.taskDetails.project?.name && <Card.Subtitle className={`mt-1 fs-6 fw-semibold fst-italic ${this.props.item.taskDetails.priority === 'HIGH' ? 'text-white' : 'text-success'}`}><i className="bi bi-folder me-1"></i>{this.props.item.taskDetails.project.name}</Card.Subtitle>}
					{this.props.item.categories?.length > 0 && <div className="mt-2 d-flex gap-1 flex-wrap">{this.props.item.categories.map(c => <Badge key={c.id} bg="light" text="dark"><i className={`bi ${getCategoryIcon(c.name)} me-1`}></i>{c.name}</Badge>)}</div>}
				</Card.Body>
				<Card.Footer onClick={e => e.stopPropagation()}>
					<div className="d-flex gap-2">
						<Button size="sm" variant="success" onClick={() => this.openDetails('COMPLETED')}>Mark as Complete</Button>
						{!isRecurringTask && <Button size="sm" variant="primary" onClick={() => this.openDetails('REMINDER')}>Schedule</Button>}
					</div>
				</Card.Footer>
			</Card>
				</div>
			</div>

			<Modal show={this.state.showDetails} onHide={this.closeDetails} fullscreen="sm-down" scrollable>
				<Modal.Header closeButton>
					<Modal.Title>{this.props.item.taskDetails.name}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<TaskDetailsComponent
						projects={this.props.projects}
						categories={this.props.categories}
						showToast={this.props.showToast}
						allItems={this.props.allItems}
						contexturl={this.props.contexturl}
						onItemChanged={this.props.onItemChanged}
						key={detailKey}
						activeSection={this.state.activeSection}
						showTopFields={this.state.showTopFields}
						currentItem={this.props.item}
						items={this.props.items}
					/>
				</Modal.Body>
			</Modal>
		</div>
	}
}
export default TaskItem;
